import { Button } from '@eureca/ui';
import { ConsultantsMenu } from '@/shared/consultants-menu/ConsultantsMenu';
import { CheckIcon } from './icons';

export interface JobCreateSuccessPageProps {
  onContinueEditing: () => void;
  onBackToJobs: () => void;
}

export function JobCreateSuccessPage({
  onContinueEditing,
  onBackToJobs,
}: JobCreateSuccessPageProps) {
  return (
    <div className="flex min-h-dvh flex-row bg-muted">
      <ConsultantsMenu activeId="jobs" />

      <main className="flex flex-1 flex-col items-center justify-center gap-8 bg-card px-8 py-16">
        <section
          aria-live="polite"
          className="flex w-full max-w-[640px] flex-col items-stretch gap-5"
        >
          <div className="flex flex-col items-center gap-5">
            <div
              aria-hidden
              className="flex size-16 items-center justify-center rounded-full bg-secondary text-primary"
            >
              <CheckIcon className="size-6" />
            </div>
            <div className="flex flex-col items-center gap-2.5">
              <h1 className="text-center text-4xl font-medium leading-none tracking-tight text-foreground">
                Vaga criada com sucesso
              </h1>
              <p className="text-center text-base leading-6 text-accent-foreground">
                Sua vaga foi salva como rascunho. Você pode continuar editando a qualquer momento.
              </p>
            </div>
          </div>

          <div className="flex flex-row justify-center gap-2 pt-3">
            <Button onClick={onContinueEditing}>Continuar editando</Button>
            <Button variant="outline" onClick={onBackToJobs}>
              Conferir vagas
            </Button>
          </div>
        </section>
      </main>
    </div>
  );
}
